<template>
  <div>
    <v-layout row align-baseline v-if="rsvp">
      <v-flex xs2>
        <v-chip label outline color="blue">
          <span v-if="clockIn && clockOut">
            Event Timecard
          </span>

          <span v-else-if="clockIn">
            Clock Out
          </span>
          <span v-else>
            Clock In
          </span>
        </v-chip>
      </v-flex>

      <v-flex xs10>
        <v-layout row align-baseline justify-start>
          <v-flex v-if="!clockIn">
            <v-btn @click="doClockIn()" color="success">
              Clock In Now
            </v-btn>
          </v-flex>

          <v-flex v-if="clockIn && !clockOut">
            <v-btn @click="doClockOut()" color="success">
              Clock Out Now
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout v-if="clockIn || clockOut">
          <span class="caption subtle mr-4" v-if="clockIn">Clocked In {{ clockIn | moment("MMMM DD h:mma") }}</span>
          <span class="caption subtle" v-if="clockOut">Clocked Out {{ clockOut | moment("MMMM DD h:mma") }}</span>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>

import { mapState } from 'vuex';
import invitesApi from '@/api/invites';

export default {
  props: [ 'eventId' ],
  created () {
    this.fetchMyRSVP(this.eventId)
  },

  data: function () {
    return {
      attending: null,
      rsvpLoading: false,
      rsvp: null,
      rsvpPending: false,
      clockPending: false,
      showChange: false,
      lastResponded: null,
      clockIn: null,
      clockOut: null,
    }
  },

  methods: {
    fetchMyRSVP(eventId) {
      this.rsvpLoading = true
      invitesApi.rsvpForEvent(eventId, rsvp => {
        this.rsvp = rsvp
        this.attending = rsvp.attending
        this.clockIn = rsvp.clock_in
        this.clockOut = rsvp.clock_out
        this.rsvpLoading = false
      })
    },

    doClockIn() {
      this.clockPending = true
      invitesApi.clockIn(
        { eventId: this.eventId }
      ).then((rsvp) => {
        this.clockPending = false
        this.clockIn = rsvp.clock_in
      })
    },
    doClockOut() {
      this.clockPending = true
      invitesApi.clockOut(
        { eventId: this.eventId }
      ).then((rsvp) => {
        this.clockPending = false
        this.clockOut = rsvp.clock_out
      })
    }
  },
}
</script>
